export default __webpack_public_path__ + "static/media/0xf915fdda4c882731c0456a4214548cd13a822886.1b99eac5.webp";